import React from 'react';
import { useTranslation } from 'react-i18next';
import SvgMenu from '../../../../../play-core/icons/Menu';
import { useAnalyticsDispatch } from '../../../analytics/AnalyticsContext';
import { useDataDispatch } from '../../../providers/DataProvider/DataContext';
import { renderEntries } from '../../../utils/list-entries-render-helper';
import { Menu } from '../../Menu/Menu';
import { jsx as _jsx } from "react/jsx-runtime";
export const PlayMenu = ({
  menuEntries,
  icon = /*#__PURE__*/_jsx(SvgMenu, {}),
  iconSize,
  colorSet
}) => {
  const {
    t
  } = useTranslation();
  const dispatch = useDataDispatch();
  const analytics = useAnalyticsDispatch();
  return /*#__PURE__*/_jsx(Menu, {
    icon: icon,
    iconSize: iconSize,
    colorSet: colorSet,
    ariaLabel: `${t('global.menu')} ${t('global.open')}`,
    ariaLabelOpen: `${t('global.menu')} ${t('global.close')}`,
    children: renderEntries(menuEntries, analytics, dispatch)
  });
};